import styled from 'styled-components'

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 48px;
  height: 28px;
  flex-shrink: 0;
`

export const SwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: ${({ theme }) => theme.colors.action.primary.bg};
  }

  &:checked + span::before {
    transform: translateX(20px);
  }

  &:focus-visible + span {
    box-shadow: 0 0 0 3px rgba(62, 207, 142, 0.25);
  }

  &:disabled + span {
    opacity: 0.55;
    cursor: not-allowed;
  }
`

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  inset: 0;
  background-color: ${({ theme }) => theme.colors.borderStrong};
  border-radius: 999px;
  transition: background-color 0.2s ease, box-shadow 0.2s ease;

  &::before {
    position: absolute;
    content: '';
    height: 22px;
    width: 22px;
    left: 3px;
    bottom: 3px;
    background-color: #ffffff;
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.25);
    transition: transform 0.2s ease;
  }
`

export const StateLabel = styled.span`
  font-size: 0.875rem;
  min-width: 30px;
  text-align: left;
  color: ${({ theme }) => theme.colors.textSecondary};
`
